export const environment = {
  production: false,
  apiUrl: `https://minlandapp.oasisproducts.ng/api/v1`,
};
